import React from "react";
import {
  HeroBannerHighlight,
  HeroBannerContainer,
  HeroBannerTitle,
  HeroBannerTitleContainer,
  HeroBannerWrapper,
} from "../styles/components";

const HeroBannner = () => {
  return (
    <HeroBannerWrapper>
      <HeroBannerContainer>
        <HeroBannerTitleContainer>
          <HeroBannerTitle>
          Be Sure with Constellation.
          <br />
            <HeroBannerHighlight>Texas Sure.</HeroBannerHighlight>
         
          </HeroBannerTitle>
        </HeroBannerTitleContainer>
      </HeroBannerContainer>
    </HeroBannerWrapper>
  );
};

export default HeroBannner;
